document.addEventListener("DOMContentLoaded",function()
{


    function init()
    {

        inicializar_carrusel_anunciosheader();
        inicializar_carrusel_bannershome();
        inicializar_carrusel_marcasfavoritas();
        inicializarCarruselTestimoniales();
    
    
    }


    
    
    function inicializar_carrusel_anunciosheader()
    {


      
        jQuery('.carrusel-bannersenvio').slick(
            
                                                    {
                                                        slidesToShow:1,
                                                        autoplaySpeed:3000,
                                                        autoplay: true,
                                                        slidesToScroll:1,
                                                        dots: false,
                                                        arrows:false
                                                    }
            
                                                ); 

     


    }



    function inicializar_carrusel_bannershome()
    {


      
        jQuery('.carrusel-bannershome').slick(
            
                                                    {
                                                        slidesToShow:1,
                                                        autoplaySpeed:3000,
                                                        autoplay: true,
                                                        slidesToScroll:1,
                                                        dots: true,
                                                        arrows:false
                                                    }
            
                                                ); 

     


    }


    function inicializar_carrusel_marcasfavoritas()
    {


      
        jQuery('.carrusel-marcasfavoritas').slick(
            
                                                    {
                                                        slidesToShow:5,
                                                        autoplaySpeed:3000,
                                                        autoplay: true,
                                                        slidesToScroll:1,
                                                        dots: false,
                                                        arrows:true,
                                                        responsive:[
            
                                                                
                                                                    {
                                                                        breakpoint: 992,
                                                                        settings: {
                                                                        slidesToShow: 4
                                                                        }
                                                                    },
                                                                    {
                                                                        breakpoint: 660,
                                                                        settings: {
                                                                        slidesToShow: 3
                                                                        }
                                                                    },

                                                                    {
                                                                        breakpoint: 460,
                                                                        settings: {
                                                                        slidesToShow: 2
                                                                        }
                                                                    }

                                                        ]
                                                    }
            
                                                ); 

     


    }


    function inicializarCarruselTestimoniales()
    {


        jQuery('.carrusel-testimoniales').slick({
        slidesToShow:3,
        autoplay: false,
        slidesToScroll:1,
        dots: true,
      
        responsive:[

        
        {
            breakpoint: 960,
            settings: {
            slidesToShow: 2
            }
        },
        {
            breakpoint: 720,
            settings: {
            slidesToShow: 1
            }
        }
        ]
    });




    }


        
 


  init();

  
  
});